import moment from 'moment'
import _ from 'lodash'
import { getHabilitations } from '../utils/habilitations'

async function findData(context) {
    const [storeHabilitations, orgHabilitations] = await getHabilitations(context)
    const stores = storeHabilitations.map(hab => _.get(hab, 'store._id'))
    const organizations = orgHabilitations.map(hab => _.get(hab, 'organization._id'))

    const habQuery = stores.length || organizations.length
        ? {
            $or: [
                { store: { $in: stores } },
                { organizations: { $in: organizations } }
            ],
        }
        : {}
    const groupQuery = { group: new global.ObjectID(context.group.id) }

    const generalSettings = await global.app.S.GeneralSettings.collection.findOne({ group: new global.ObjectID(context.group.id) })

    // Fiscal year logic similar to customDashboardElement.js
    const fiscalYearStartDate = `${generalSettings.monthNumber}-${generalSettings.month}`
    const fiscalYearStart = moment.utc(fiscalYearStartDate, 'DD-MM')

    const endDate = moment.utc().subtract(generalSettings.delay, 'days')
    const endDatePlusOne = endDate.clone().add(1, 'days')

    let startDateN
    if (endDatePlusOne.isSameOrAfter(fiscalYearStart)) {
        startDateN = fiscalYearStart.clone()
    } else {
        startDateN = fiscalYearStart.clone().subtract(1, 'years')
    }
    const endDateN = endDate.clone()

    const startDateN1 = startDateN.clone().subtract(1, 'years')
    const endDateN1 = endDateN.clone().subtract(1, 'years')

    const automaticReason = await global.app.S.Reason.collection.findOne({ automatic: true, ...groupQuery })
    const automaticReasonId = automaticReason ? automaticReason._id : null

    const nowN1 = moment.utc().subtract(1, 'years')

    const segmentSwitch = (stepField, reasonField) => ({
        $switch: {
            branches: [
                {
                    case: { $in: [stepField, ["pending", "review"]] },
                    then: "segment_manager"
                },
                {
                    case: { $eq: [stepField, "inProgress"] },
                    then: "segment_validator"
                },
                {
                    case: { $eq: [stepField, "risk"] },
                    then: {
                        $cond: [
                            { $eq: [reasonField, automaticReasonId] },
                            "segment_risk_auto",
                            "segment_risk_validator"
                        ]
                    }
                },
                {
                    case: { $eq: [stepField, "noRisk"] },
                    then: "segment_no_risk_validator"
                }
            ],
            default: "unknown"
        }
    })

    const getPipelineN = (startDate, endDate) => [
        {
            $match: {
                ...habQuery,
                ...groupQuery,
                'date.lt': { $gte: startDate.toDate(), $lte: endDate.toDate() }
            }
        },
        {
            $project: {
                segment: segmentSwitch("$workflow.step", "$reason")
            }
        },
        {
            $group: {
                _id: "$segment",
                count: { $sum: 1 }
            }
        }
    ]

    const getPipelineN1 = (startDate, endDate, targetDate) => [
        {
            $match: {
                ...habQuery,
                ...groupQuery,
                'date.lt': { $gte: startDate.toDate(), $lte: endDate.toDate() }
            }
        },
        {
            $addFields: {
                historyAtDate: {
                    $arrayElemAt: [
                        {
                            $filter: {
                                input: { $ifNull: ["$workflow.processingHistory", []] },
                                as: "h",
                                cond: { $lte: ["$$h.date", targetDate.toDate()] }
                            }
                        },
                        -1
                    ]
                }
            }
        },
        {
            $project: {
                effectiveStep: { $ifNull: ["$historyAtDate.status.step", "$workflow.step"] },
                effectiveReason: { $ifNull: ["$historyAtDate.reason", "$reason"] }
            }
        },
        {
            $project: {
                segment: segmentSwitch("$effectiveStep", "$effectiveReason")
            }
        },
        {
            $group: {
                _id: "$segment",
                count: { $sum: 1 }
            }
        }
    ]

    const [dataN, dataN1] = await Promise.all([
        global.app.S.Alert.collection.aggregate(getPipelineN(startDateN, endDateN)).toArray(),
        global.app.S.Alert.collection.aggregate(getPipelineN1(startDateN1, endDateN1, nowN1)).toArray()
    ])

    const formatData = (mongoData, periodLabel) => {
        const result = {
            date: periodLabel,
            segment_manager: 0,
            segment_validator: 0,
            segment_risk_auto: 0,
            segment_risk_validator: 0,
            segment_no_risk_validator: 0
        }
        mongoData.forEach(item => {
            if (result.hasOwnProperty(item._id)) {
                result[item._id] = item.count
            }
        })
        return result
    }

    const resN = formatData(dataN, String(startDateN.year()))
    const resN1 = formatData(dataN1, String(startDateN1.year()))

    const dashboardDates = [startDateN.format('DD-MM'), endDateN.format('DD-MM')]

    return [
        {
            id: "000000000000000000000013",
            subTitle: {
                text: `${context.tc('fromFiscalYearStartTo')} ${dashboardDates[1]}`,
                font: '11px',
                color: '#888383'
            },
            data: [resN1, resN]
        }
    ]
}

export const entity = {
    name: 'FiscalYearComparisonHistogram',
    dashboard: true,
    fields: ["id", "subTitle", "data"],
    find: function(context, callback) {
        this.prepareContext(context, 'L', (error, context) => {
            if (error) callback(error)
            else
                findData(context)
                    .then(objects => callback(null, objects))
                    .catch(error => callback(error))
        })
    }
}
